import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { RoleAccountGuard } from '../../guards/role-account.guard';
import { TelemarketingComponent } from '../../pages/telemarketing/telemarketing.component';

export const telemarketingRoutes: Routes = [
  {
    path: 'calendar/telemarketing',
    component: TelemarketingComponent,
    resolve: { title: TitleResolver }, 
    canActivate: [RoleAccountGuard],
    data: { 
      title: 'titles-menu-pages.telemarketing', 
      role: ['Admin', 'Supervisor', 'Agent', 'Telemarketing'], 
      account_type: ['supplier'] 
    },
  },
  {
    path: 'calendar/telemarketing/:reference',
    component: TelemarketingComponent,
    resolve: { title: TitleResolver }, 
    canActivate: [RoleAccountGuard],
    data: { 
      title: 'titles-menu-pages.telemarketing', 
      role: ['Admin', 'Supervisor', 'Agent', 'Telemarketing'], 
      account_type: ['supplier'] 
    },
  },
];

export function getFilteredTelemarketingRoutes(accountType: string, role: string): Routes {
  return telemarketingRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}